<!--
/*******************************************************************************
*@ 컴포넌트명   : FaqComponent.vue
*@ 컴포넌트설명 : faq컴포넌트
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article class="contents">
    <div class="total-count">
      {{ $t("MCOM-0000079") }} : {{faqConts.totalCnt}}
      <div class="info info-help" @click="helpPopup = !helpPopup">
        <i class="icon icon-help" />
      </div>
    </div>
    <dl class="accordion-box" role="presentation">
      <div v-for="item in faqList" :key="item.id">
        <div
          :id="groupId + '-' + item.id"
          :class="{ 'is-active': item.active }"
          class="accordion-item"
        >
          <dt class="accordion-item-title">
            <div @click="toggle(item)" class="accordion-item-trigger">
              <i v-if="item.faqIconQ" class="icon icon-faq-q" />
              <h4 class="accordion-item-title-text" v-html="$htmlDecode(item.title)"></h4>
              <i class="icon icon-dropdown-m-arrow" />
            </div>
          </dt>
          <dd v-if="item.active" class="accordion-item-details">
            <i v-if="item.faqIconA" class="icon icon-faq-a" />
            <div v-html="$htmlDecode(item.details)" class="accodion-item-details-inner"></div>
          </dd>
        </div>
      </div>
    </dl>
    <modal-pop
      :opened.sync="helpPopup"
      class="modal"
      :title="$t('MHLP-02-01-03-01')"
      :no-negative-button="true"
      @confirm="!isLogin && siteCode == $config.SITECODE_OGHCM ?helpPopup = !helpPopup:$goToTel($t(`지점별콜번호_${siteCode}`))"
      @cancel="helpPopup = !helpPopup"
      :cancel="'MPRS-01-01-03-10'"
      :confirm="!isLogin && siteCode == $config.SITECODE_OGHCM ?'MPAY-02-01-25-17':'MHLP-04-01-01-03'"
    >
      <template #content>
        <div>
          {{/*찾으시는 내용이 없는 경우에는 상담원에게 직접 질문하실 수 있습니다.*/ $t("MHLP-02-01-03-02") }}
          <template>
            <p class="faq bold" v-if="operGroupCd=='VN2' && isLogin">
              {{ $t(`oghni_지점명칭`) }}
              <span>{{ $t(`지점별전화번호_oghni`) }}</span>
            </p>
            <p class="faq bold" v-else>
              {{ $t(`${siteCode}_지점명칭`) }}
              <span>{{ $t(`지점별전화번호_${siteCode}`) }}</span>
            </p>
          </template>
          <template v-if="siteCode == $config.SITECODE_OGHCM && !isLogin">
            <p class="faq bold">
              {{ $t(`oghni_지점명칭`) }}
              <span>{{ $t(`지점별전화번호_oghni`) }}</span>
            </p>
          </template>
        </div>
      </template>
    </modal-pop>
  </article>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import { unWatchStore, unWatchHook, watchBoardList } from "@/mixins/basicComponent";
export default {
  mixins: [unWatchStore, unWatchHook, watchBoardList],
  name: "FaqComponent",
  props: {
    boardID: {
      type: String,
      required: true,
    },
    multiple: { type: Boolean, default: false },
  },
  computed: {
    ...mapFields(["lang", "siteCode", "operGroupCd"]),
    ...mapGetters(["isLogin"]),
  },
  mounted() {
    this.groupId = this.$el.id;
    this.firstCall();
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      groupId: null,
      faqList: {},
      faqConts: {},
      page: 1,
      helpPopup: false,
    };
  },
  methods: {
    toggle(item) {
      this.faqList.forEach(v => {
        if (v.id == item.id) {
          v.active = !item.active;
        } else {
          v.active = false;
        }
      });
    },
    firstCall() {
      (this.page = 1), this.noticeCall(this.page);
    },
    noticeCall(page) {
      if (page == null) {
        this.page++;
      } else {
        this.page = 1;
      }
      if (this.operGroupCd == "VN2") {
        this.requestData = {
          boardID: this.boardID, //게시판종류
          displayCnt: "10",
          dmndCnt: this.page,
          operGroupCd: "VN1", //베트남 하노이 지점일 경우 호치민 조건으로 검색(베트남은 동일한 FAQ 출력)
        };
      } else {
        this.requestData = {
          boardID: this.boardID, //게시판종류
          displayCnt: "10",
          dmndCnt: this.page,
          operGroupCd: this.operGroupCd, //국가
        };
      }
      //공지사항 FAQ 서식약관 리스트 조회 API 호출
      this.$post("/commonbiz/board/listsearch", this.requestData, this.faqSuc);
    },
    faqSuc(res) {
      if (this.page === 1) {
        this.faqConts = {
          //FAQ 호출 결과
          ...res.outItem,
        };
      } else {
        this.faqConts.boardList = [...this.faqConts.boardList, ...res.outItem.boardList];
      }
      const list = [];
      this.faqConts.boardList.forEach((v, i) => {
        if (this.lang === "KOR") {
          list.push({
            id: i + 1,
            active: false,
            faqIconQ: true,
            faqIconA: true,
            title: v.hanglTitlCtnt,
            details: v.hanglBultnCtnt,
          });
        } else if (this.lang === "ENG") {
          list.push({
            id: i + 1,
            active: false,
            faqIconQ: true,
            faqIconA: true,
            title: v.engTitlCtnt,
            details: v.engBultnCtnt,
          });
        } else {
          list.push({
            id: i + 1,
            active: false,
            faqIconQ: true,
            faqIconA: true,
            title: v.lcalTitlCtnt,
            details: v.lcalBultnCtnt,
          });
        }
      });
      this.faqList = list;
    },
    handleScroll() {
      this.scrolled = window.scrollY > 0;
      if (this.page * 10 < this.faqConts.totalCnt) {
        this.noticeCall();
      }
    },
  },
};
</script>
